import {ENTITY_STORE, ENTITY_REMOVE} from '@actions/actionTypes';

const initialState = {};

const entities = (state = initialState, action) => {
    switch (action.type) {
        case ENTITY_STORE: {
            return {
                ...state,
                [action.data.name]: action.data.data,
            };
        }

        case ENTITY_REMOVE: {
            // eslint-disable-next-line no-unused-vars -- key is intentionally omitted via rest spread
            const {[action.name]: _omit, ...rest} = state;

            return rest;
        }

        default:
            return state;
    }
};

export default entities;
